// =====================================
//
//   Other Controller
//   Author: Wayne
//   createtime: 2016 / 08 / 30
//
// =====================================

window.InifECMobileApp.controller("OrderController", ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', 'UserService', 'OrderService', 'ShoppingCartService', 'PointService', '$PreviousState', 'ProductDeliveryService', 'ProductUtil',
	function($scope, $state, $timeout, $rootScope, $stateParams, UserService, OrderService, ShoppingCartService, PointService, $PreviousState, ProductDeliveryService, ProductUtil) {

        var getMemberPointsBalance = function() {
            PointService.getMemberPointsBalance().then(function(result){
                if(result){
                    $scope.pointsBalanceRec = result;
                    $scope.points = $scope.pointsBalanceRec.pointsbalance;
                    $scope.pointsEnableFlag = $scope.pointsBalanceRec.enableflag;
                }
            }, function(error){
                
            });
        };

        var getOrderInfo = function() {
            $scope.isLoading = true;
            OrderService.getOrderInfo($scope.orderid).then(function(result) {
                if(result) {
                    $scope.order = result;

                    // 外面列表會cache，因此每次進來都更新列表的狀態
                    $rootScope.$broadcast('ORDER_STATUS_UPDATE', {
                        orderid: $scope.orderid,
                        orderstatus: $scope.order.orderstatus
                    });

                    $scope.paymentmethod = Paytype_SinopacCreditCard;

                    if(result.paymentmethod > 0) {
                        $scope.paymentmethod = result.paymentmethod;
                    }

                    if($scope.paymentmethod == Paytype_SinopacATM) {
                        //getAtmInfo();
                    }

                    if($scope.order.orderExtraFeeLogs && $scope.order.orderExtraFeeLogs.logs) {
                        $scope.order.extraFeeList = [];
                        $.map($scope.order.orderExtraFeeLogs.logs, function(value, index) {

                            value.canRefund = false;

                            if(value.status == 400) {

                                if(value.paidtime) {
                                    var now = Date.now();
                                    var differ = now - value.paidtime;
                                    var timeago = differ / (60 * 60 * 24 * 1000);
                                    if(timeago <= 2) {
                                        value.canRefund = true;
                                    }
                                }
                            }

                            $scope.order.extraFeeList.push(value);
                        });
                    }

                    getRefundInfos();
                    getTotalPrice();
                    checkRefund();
                    stepScrollToStatus();
                }

                $scope.isUploadError = false;
                $scope.isLoading = false;
            }, function(error) {
                if(error && (error.code == 'error.rscNotExist' || error.code == 'error.privilege.noReadable')) {
                    $scope.isOrderNotExist = true;
                } else {
                    $scope.isError = true;
                }

                $scope.isUploading = false;
                $scope.isLoading = false;
            });
        };

        var getTotalPrice = function(){

            var productTotal = 0;
            var shippingFee = 0;
            var confidentialFee = 0;
            var extraFeeTotal = 0;
            var faxTotal = 0;
            var order = $scope.order;

            if(order.orderitems && order.orderitems.length > 0) {
                for(var i = 0; i < order.orderitems.length; i++) {
                    var orderitem = order.orderitems[i];

                    productTotal += getProductTotalPrice(orderitem);
                }
            }

            shippingFee = order.shippingFee;
            confidentialFee = order.confidentialFee;

            if(order.orderExtraFeeLogs && order.orderExtraFeeLogs.totalExtraFee) {
                extraFeeTotal = order.orderExtraFeeLogs.totalExtraFee;
            }

            faxTotal = productTotal + shippingFee;
            faxTotal = window.Math.round(faxTotal * 1.05);

            $scope.totalMap.productTotal = productTotal;
            $scope.totalMap.shippingFee = shippingFee;
            $scope.totalMap.confidentialFee = confidentialFee;
            $scope.totalMap.extraFeeTotal = extraFeeTotal;
            $scope.totalMap.faxTotal = faxTotal;
        };

        var checkRefund = function() {

            $scope.order.timeMap = {};

            if(Array.isArray($scope.order.changelogs) && $scope.order.changelogs.length > 0) {
                // 分析change log並且
                var changelogs = $scope.order.changelogs;
                for(var j = 0; j < changelogs.length; j++) {
                    var log = changelogs[j];
                    if(log.orderstatus == 201) {
                        // 待審核
                        if(!$scope.order.timeMap[201]) {
                            $scope.order.timeMap[201] = log.updatetime;
                        }
                    } else if(log.orderstatus == 0 || log.orderstatus == 202) {
                        // 待審核
                        if(!$scope.order.timeMap[202]) {
                            $scope.order.timeMap[202] = log.updatetime;
                        }
                    } else if(log.orderstatus == 250) {
                        // 待付款(後審)
                        if(!$scope.order.timeMap[250]) {
                            $scope.order.timeMap[250] = log.updatetime;
                        }
                    } else if(log.orderstatus == 251) {
                        // 等待對帳(後審)
                        if(!$scope.order.timeMap[251]) {
                            $scope.order.timeMap[251] = log.updatetime;
                        }
                    } else if(log.orderstatus == 302) {
                        // 審核中
                        if(!$scope.order.timeMap[302]) {
                            $scope.order.timeMap[302] = log.updatetime;
                        }
                    } else if(log.orderstatus == 303) {
                        // 不合格
                        if(!$scope.order.timeMap[303]) {
                            $scope.order.timeMap[303] = log.updatetime;
                        }
                    } else if(log.orderstatus == 400) {
                        // 完成付款
                        if(!$scope.order.timeMap[400]) {
                            $scope.order.timeMap[400] = log.updatetime;
                        }
                    } else if(log.orderstatus == 401) {
                        // 待退貨
                        if(!$scope.order.timeMap[401]) {
                            $scope.order.timeMap[401] = log.updatetime;
                        }
                    } else if(log.orderstatus == 402) {
                        // 已退貨
                        if(!$scope.order.timeMap[402]) {
                            $scope.order.timeMap[402] = log.updatetime;
                        }
                    } else if(log.orderstatus >= 500 && log.orderstatus < 600) {
                        // 商品製作中
                        if(!$scope.order.timeMap[500]) {
                            $scope.order.timeMap[500] = log.updatetime;
                        }
                    } else if(log.orderstatus == 600) {
                        // 物流入庫（可取貨）
                        if(!$scope.order.timeMap[600]) {
                            $scope.order.timeMap[600] = log.updatetime;
                        }
                    } else if(log.orderstatus == 602) {
                        // 貨物配送中
                        if(!$scope.order.timeMap[602]) {
                            $scope.order.timeMap[602] = log.updatetime;
                        }
                    } else if(log.orderstatus == 601) {
                        // 物流入庫（待配送）
                        if(!$scope.order.timeMap[601]) {
                            $scope.order.timeMap[601] = log.updatetime;
                        }
                    } else if(log.orderstatus == 700) {
                        // 物流入庫 or 貨物配送中
                        if(!$scope.order.timeMap[700]) {
                            $scope.order.timeMap[700] = log.updatetime;
                        }
                    } else if(log.orderstatus == 801) {
                        // 人工退款中
                        if(!$scope.order.timeMap[801]) {
                            $scope.order.timeMap[801] = log.updatetime;
                        }
                    } else if(log.orderstatus == 802) {
                        // 退款完成
                        if(!$scope.order.timeMap[802]) {
                            $scope.order.timeMap[802] = log.updatetime;
                        }
                    } else if(log.orderstatus == 803) {
                        // 退貨審查失敗
                        if(!$scope.order.timeMap[803]) {
                            $scope.order.timeMap[803] = log.updatetime;
                        }
                    } else if(log.orderstatus == 804) {
                        // 重印
                        if(!$scope.order.timeMap[804]) {
                            $scope.order.timeMap[804] = log.updatetime;
                        }
                    } else if(log.orderstatus == 805) {
                        // 重印
                        if(!$scope.order.timeMap[805]) {
                            $scope.order.timeMap[805] = log.updatetime;
                        }
                    } else if(log.orderstatus == 806) {
                        // 部分退款申請通過，待退款
                        if(!$scope.order.timeMap[806]) {
                            $scope.order.timeMap[806] = log.updatetime;
                        }
                    } else if(log.orderstatus == 807) {
                        // 已部分退款
                        if(!$scope.order.timeMap[807]) {
                            $scope.order.timeMap[807] = log.updatetime;
                        }
                    }
                }
            }


            $scope.order.canRefund = false;

            // 檢查是否能退款

            var paymentTime = $scope.order.timeMap[700];

            if(paymentTime) {
                var now = Date.now();
                var differ = now - paymentTime;
                var timeago = differ / (60 * 60 * 24 * 1000);

                if(timeago <= 2) {
                    $scope.order.canRefund = true;
                }
            }
        };

        var stepScrollToStatus = function(){
            var orderStatus = $scope.order.orderstatus;
            $timeout(function(){

                document.getElementById("step-list-wrapper").scrollLeft += 
                ($(".status"+ orderStatus).offset() || {'left': 0} ).left - ($(".step-list-wrapper").outerWidth() - $(".status"+orderStatus).outerWidth())/2;
            }, 0);
        };

        var reOrder = function() {
            
            if($scope.isReOrdering){
                return;
            }

            $scope.isReOrderingError = false;
            $scope.isReOrderItemNotExist = false;
            $scope.isReOrdering = true;
            var orderid = $scope.orderid;
            ShoppingCartService.reOrderToShoppingCart(orderid).then(function(result) {
                if(result){
                    $state.go(window.STATES.CART);
                }else {
                    $scope.isReOrderingError = true;
                    $scope.isReOrdering = false;
                }                
            }, function(error){
                if(error && error.code == 'error.rscNotExist') {
                    $scope.isReOrderItemNotExist = true;
                } else {
                    $scope.isReOrderingError = true;
                }

                $scope.isReOrdering = false;
            });
        }

        var refund = function() {

            $rootScope.$broadcast('OPEN_CONFIRM_REFUND_MODAL', {
                orderid: $scope.orderid,
                callback: function() {
                    $scope.order.orderstatus = 800;
                }
            });
        };

        var confirmPayment = function() {

            $rootScope.$broadcast('OPEN_CONFIRM_PAYMENT_MODAL', {
                orderid: $scope.orderid,
                confirmOrderCallback: function() {
                    getOrderInfo();
                }
            });
        };

        var getOrderItemCoverImage = function(orderitem) {
            
            if(!orderitem || !orderitem.coverurl){
                return "about:blank";
            }

            return orderitem.coverurl.replace('medium', 'small');
        };

        var getStepColorClass = function() {

            if(!$scope.order) {
                return;
            }

            switch($scope.order.orderstatus) {
                case 0:
                case 202:
                case 303:
                case 800:
                case 801:
                case 803:
                case 806:
                    return 'red';
                case 804:
                case 805:
                    return 'green';
                default:
                    return 'orange';
            }
        }

        // --------------------------------
        // 重新上傳訂單檔案
        // --------------------------------
        var reuploadOrderitemFile = function() {

            $rootScope.$broadcast('OPEN_REUPLOAD_ORDERITEM_FILE_MODAL', {
                orderid: $scope.orderid,
                orderitems: $scope.order.orderitems,
                callback: function() {
                    $scope.order.orderstatus = 301;
                    $rootScope.$broadcast('ORDER_STATUS_UPDATE', {
                        orderid: $scope.orderid,
                        orderstatus: $scope.order.orderstatus,
                    });
                }
            })
        }

        // --------------------------------
        // 上一頁
        // --------------------------------
        var goBack = function() {

            var backState = $PreviousState.getOrderPrevious();

            $PreviousState.goBack(backState);
        }

        // --------------------------------
        // 作廢訂單
        // --------------------------------
        var discardOrder = function(order) {

            var orderid = order.orderid;
            $rootScope.$broadcast("OPEN_CONFIRM_MODAL", {
                title: "取消訂單",
                description: "即將取消訂單「" + orderid + "」，確定嗎？",
                callback: function(result) {
                    if(result){                        

                        OrderService.discardOrder(orderid).then(function(result) {

                            getOrderInfo();
                            $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                                title: '取消訂單成功',
                            });
                        }, function(error) {
                            $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                                title: '系統發生錯誤',
                            });
                        });
                    }
                }
            });
        }

        // --------------------------------
        // 開啟補收款記錄modal
        // --------------------------------
        var showOrderExtraFeeLogs = function() {

            $rootScope.$broadcast('OPEN_ORDER_EXTRAFEE_LIST_MODAL', {
                extraFeeList: $scope.order.extraFeeList,    
            });
        }

        // --------------------------------
        // 確認稿件完成，準備送印
        // --------------------------------
        var checkOrderReview = function() {

            if($scope.isCheckOrderReview) {
                return;
            }

            var title = "確認稿件無誤",
                description = "確認無誤後，將要把訂單的商品送印，確定嗎？"

            $rootScope.$broadcast('OPEN_CONFIRM_MODAL', {
                title: title,
                description: description,
                callback: function(isConfirm) {
                    if(isConfirm) {

                        if($scope.isCheckOrderReview) {
                            return;
                        }
                        
                        $scope.isCheckOrderReview = true;

                        OrderService.checkOrderReview($scope.orderid).then(function(result) {

                            if(result) {
                                getOrderInfo();
                                $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                                    title: '確認稿件成功',
                                });
                            } else {
                                $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                                    title: '系統發生錯誤',
                                });
                            }

                            $scope.isCheckOrderReview = false;
                            
                        }, function(error) {

                            i$rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                                title: '系統發生錯誤',
                            });
                            
                            $scope.isCheckOrderReview = false;
                        });
                    }
                }
            });
        }

        // --------------------------------
        // 檢查是否可作廢
        // --------------------------------
        var canDiscard = function() {

            if(!$scope.order) {
                return false;
            }

            if(!$scope.order.ispaid) {
                return $scope.order.orderstatus != 201 && $scope.order.orderstatus < 400;
            } else {
                return $scope.order.orderstatus != 201 && $scope.order.orderstatus != 300 && $scope.order.orderstatus < 400;
            }
        }

        // --------------------------------
        // 作廢已付款訂單
        // --------------------------------
        var discardPaidOrder = function() {

            $rootScope.$broadcast('OPEN_CONFIRM_PAID_REFUND_MODAL', {
                order: $scope.order,
                callback: function() {
                    $scope.order.orderstatus = 801;
                    $scope.order.timeMap[801] = Date.now();
                    $rootScope.$broadcast('ORDER_STATUS_UPDATE', {
                        orderid: $scope.orderid,
                        orderstatus: $scope.order.orderstatus,
                    });
                }
            });
        }

        // --------------------------------
        // 取得加工總額
        // --------------------------------
        var getTotalProcessPrice = function(orderitem) {

            var price = ShoppingCartService.getTotalProcessPrice(orderitem);

            if(price < 0) {
                return 0;
            } else {
                return price;
            }
        }

        // --------------------------------
        // 取得商品總額
        // --------------------------------
        var getProductTotalPrice = function(orderitem) {

            var price = ShoppingCartService.getProductTotalPrice(orderitem);

            if(price < 0) {
                return 0;
            } else {
                return price;
            }
        }

        // --------------------------------
        // 取得特殊加工費用總額
        // --------------------------------
        var getTotalOfferProcessPrice = function(orderitem) {
            
            var price = ShoppingCartService.getTotalOfferProcessPrice(orderitem);

            return price;
        }

        // -------------------------------
        // 取得預計出貨日
        // -------------------------------
        var getCartDelivery = function() {

            var cartDelivery = 0;

            if(!$scope.order || !$scope.order.orderitems || $scope.order.orderitems.length == 0) {
                return cartDelivery;
            }

            for(var i = 0; i < $scope.order.orderitems.length; i++) {
                var item = $scope.order.orderitems[i];

                if(item.spec) {
                    var itemDelivery = parseInt(item.spec.deliveryDate / 86400000);
                    var processDelivery = ProductDeliveryService.getProcessDelivery(item.pdtClass, item.spec.process);
                    var specDelivery = ProductDeliveryService.getSpecDelivery(item.pdtClass, item.spec);
                    var totalDelivery = itemDelivery + processDelivery + specDelivery;
                    
                    if(totalDelivery > cartDelivery) {
                        cartDelivery = totalDelivery;
                    }
                }
            }

            return cartDelivery;
        }

        // --------------------------------
        // 組合退款記錄
        // --------------------------------
        var getRefundInfos = function() {

            $scope.refundInfos.length = 0;

            if($scope.order.fullRefundInfo && $scope.order.fullRefundInfo.refundStatus == 802) {
                $scope.refundInfos.push($scope.order.fullRefundInfo);
            }

            if($scope.order.partialRefundInfos && $scope.order.partialRefundInfos.length > 0) {

                for(var i = 0; i < $scope.order.partialRefundInfos.length; i++) {
                    var partialRefund = $scope.order.partialRefundInfos[i];

                    if(partialRefund.refundStatus == 802) {
                        $scope.refundInfos.push(partialRefund);
                    }
                }
            }
        } 

        // --------------------------------
        // 開啟退款記錄modal
        // --------------------------------
        var showRefundInfos = function() {

            $rootScope.$broadcast('OPEN_ORDER_REFUND_LOG_LIST_MODAL', {
                refundInfos: $scope.refundInfos,    
            });
        }

        // --------------------------------
        // 取得延遲時間
        // --------------------------------
        var getOrderDelayDay = function(order) {

            if(!order || !order.shipDelayTime || order.shipDelayTime <= 0) {
                return '-';
            }

            var delayDay = order.shipDelayTime / (1000*60*60*24);
            delayDay = parseInt(delayDay, 10);

            return delayDay;
        }

        // ------------------------------
        // 取得訂單的愛心碼機構名稱
        // ------------------------------
        var getOrderLoveCodeText = function(preppendText) {

            if(!preppendText) {
                preppendText = '';
            }

            if(!$scope.order || !$scope.order.loveCode) {
                return '';
            }

            for(var i = 0; i < default_loveCodeList.length; i++) {
                var loveCode = default_loveCodeList[i];

                if(loveCode.code == $scope.order.loveCode) {
                    return preppendText + loveCode.name;
                }
            }

            return '';
        }

        // ------------------------------
        // 取得訂單物流查詢網址
        // ------------------------------
        var getOrderShipmentSearchUrl = function() {

            if($scope.isGettingSearchUrl) {
                return;
            }

            $scope.isGettingSearchUrl = true;

            OrderService.getOrderShipmentSearchUrl($scope.orderid, $scope.order.shippingCompanyType).then(function(url){

                if(url) {
                    $scope.isGettingSearchUrl = false;

                    var newWindow = window.open(url, "_blank");
                    newWindow.focus();
                }

            }, function(error) {
                console.log(error);
            })
        }

        // -------------------------------
        // 編輯收件資訊
        // -------------------------------
        var editDelivery = function() {

            if($scope.isUpdateDelivery) {
                return;
            }

            $rootScope.$broadcast('OPEN_EDIT_DELIVERY_MODAL', {
                isShowSaveButton: false,
                callback: function(delivery, addressInfo, isConfidentialDelivery, senderInfo, statusResult, shippingFeeInfo) {

                    if(delivery === undefined || addressInfo === undefined || statusResult === undefined) {
                        return;
                    }

                    if(isConfidentialDelivery && senderInfo === undefined) {
                        return;
                    }

                    if($scope.isUpdate) {
                        return;
                    }

                    $scope.isUpdateDelivery = true;

                    var orderid = $scope.orderid,
                        addressInfoJSON = delivery == OrderDeliveryType.HOME ? JSON.stringify(addressInfo):undefined,
                        senderInfoJSON = isConfidentialDelivery ? JSON.stringify(senderInfo):undefined;

                    OrderService.firstSetDeliveryInfo(orderid, delivery, addressInfoJSON, senderInfoJSON, isConfidentialDelivery).then(function(result) {

                        if(result) {
                            $scope.order = result;
                        }

                        $scope.isUpdateDelivery = false;
                        getOrderInfo();

                    }, function(error) {
                        $scope.isUpdateDelivery = false;
                        getOrderInfo();
                    });
                }
            });
        }

        var init = function() {
            $scope.isLoading = true;
            UserService.getUserInfo().then(function(result){
                $scope.user = result;
                $scope.isLoading = false;
                getOrderInfo();
                // getMemberPointsBalance();
            }, function(error){
                $scope.isLoading = false;

                $state.go(window.STATES.HOME);
            });
        };

	    //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================
        $scope.orderid = $stateParams.orderid;
        $scope.order = null;
        $scope.isLoading = false;
        $scope.isOrderNotExist = false;
        $scope.isReOrderingError = false;
        $scope.isReOrderItemNotExist = false;
        $scope.isReOrdering = false;
        $scope.pointsBalanceRec;
        $scope.points = 0;
        $scope.pointsEnableFlag = true;
        $scope.user;
        $scope.refundInfos = [];

        $scope.totalMap = {
            productTotal: 0,
            shippingFee: 0,
            confidentialFee: 0,
            extraFeeTotal: 0,
            faxTotal: 0,
        };
        
        $scope.ProductShoppingType = ProductUtil.ProductShoppingType;
        $scope.PdtSpecProps = ProductUtil.PdtSpecProps;
        $scope.isGettingSearchUrl = false;

        //==========================
        //  Methods
        //==========================
        $scope.reOrder = reOrder;
        $scope.refund = refund;
        $scope.confirmPayment = confirmPayment;
        $scope.getOrderItemCoverImage = getOrderItemCoverImage;
        $scope.getStepColorClass = getStepColorClass;
        $scope.reuploadOrderitemFile = reuploadOrderitemFile;
        $scope.goBack = goBack;
        $scope.discardOrder = discardOrder;
        $scope.showOrderExtraFeeLogs = showOrderExtraFeeLogs;
        $scope.checkOrderReview = checkOrderReview;
        $scope.canDiscard = canDiscard;
        $scope.discardPaidOrder = discardPaidOrder;
        $scope.getTotalProcessPrice = getTotalProcessPrice;
        $scope.getTotalOfferProcessPrice = getTotalOfferProcessPrice;
        $scope.getProductTotalPrice = getProductTotalPrice;
        $scope.getCartDelivery = getCartDelivery; // 取得預計出貨日
        $scope.showRefundInfos = showRefundInfos; // 開啟部分退款記錄modal
        $scope.getOrderDelayDay = getOrderDelayDay;
        $scope.getOrderLoveCodeText = getOrderLoveCodeText; // 取得訂單的愛心碼機構名稱
        $scope.getOrderShipmentSearchUrl = getOrderShipmentSearchUrl; // 取得訂單物流查詢網址
        $scope.editDelivery = editDelivery; // 編輯收件資訊

        //==========================
        //  Init
        //==========================
        init();
	}
]);